var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"flex items-center justify-between w-full gap-twentyFive px-thirtyFive py-base overflow-hidden"},[_c('div',{staticClass:"flex justify-between gap-twentyFive"},[_c('CheckboxSkeleton',{attrs:{"pulse":""}}),_c('TextSkeleton',{attrs:{"characters":35,"pulse":""}})],1),_c('TextSkeleton',{attrs:{"characters":23,"pulse":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }